module.exports = __webpack_public_path__ + "img/State=8.6dedd767.svg";